import CircularProgress from "material-ui/CircularProgress";

const styles = {
  spinner: {
    display: 'block',
    margin: '200px auto 0',
  },
};

const LoggingIn = () => {
  return <CircularProgress style={styles.spinner}/>;
};


export default LoggingIn;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/logging-in.tsx